angular.module('octopusApp.tenants')
    .directive('tenantLogo', function() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                tenant: '=',
                maxSize: "@"
            },
            template: '<img ng-src="{{ tenant.Links.Logo | resolveLink }}?cb={{random}}" style="max-width: {{maxSize}}; max-height: {{maxSize}}" ng-show="tenant.Links.Logo"/>',
            link: function ($scope, element, attr) {
                $scope.random = Math.round(new Date().getTime() / 1000);
            }
        };
    });


//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/directives/tenant_logo.js
// module id = 2564929451058195
// module chunks = 1